var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.753 39.5563L49.4386 19.8707C50.3995 18.9098 50.3995 17.3515 49.4386 16.3907C48.4778 15.4557 46.9454 15.4557 45.9846 16.3907L28.013 34.3622L10.0415 16.3907C9.08062 15.4557 7.52236 15.4557 6.56148 16.3907C5.6006 17.3515 5.6006 18.9098 6.56148 19.8707L26.273 39.5822C27.2339 40.5431 28.7922 40.5431 29.753 39.5563Z",
    fill: "#7ABF5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/Drop-Down.aef93ae74297a38b2f2a10f151dbb349.svg";
export { ForwardRef as ReactComponent };